export const maskPhone = (value: string) => {
  if (!value) {
    return '';
  }

  let maskedValue = value.replace(/\D/g, '');
  maskedValue = maskedValue.replace(/^(\d{2})(\d)/g, '($1) $2');
  maskedValue = maskedValue.replace(/(\d)(\d{4})$/, '$1-$2');
  return maskedValue;
};

export function formatPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  } else if (cleaned.length === 10) {
    const match = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  }
  return phone;
}

export const generateWhatsAppUrl = (phone: string, message?: string): string => {
  let phoneNumber = phone.replace(/[^\d]/g, '');
  phoneNumber = phoneNumber.startsWith('55') ? phoneNumber : `55${phoneNumber}`;

  return `https://wa.me/${phoneNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
